export default __webpack_public_path__ + "static/media/p4-14.8adbfaa8.png";